// Where a field's dropdown list is maintained, so a user knows where to go to change it.
// The backend supplies { kind: 'glossary'|'reference'|'table', table, glossaryCategory,
// glossaryCategoryName, referenceName, source, confidence }.

// Route spelling matches routeConfig.js ("maintanance" typo is intentional).
export const TABLE_MAINTENANCE_ROUTE = '/system-manager/lookup-table-options/table-maintanance';

const namingCaveat = (s) => (s.source === 'naming' ? ' (inferred — verify)' : '');

// Short grid/caption text, e.g. 'Glossary: Address Type'.
export const optionsSourceShortLabel = (f) => {
    const s = f.optionsSource;
    if (!s) return f.lookupDecode || '';
    if (s.kind === 'glossary') {
        return `Glossary: ${s.glossaryCategoryName || '(list undetermined)'}${namingCaveat(s)}`;
    }
    if (s.kind === 'reference') return `Ref: ${s.referenceName}${namingCaveat(s)}`;
    return `Decoded by ${s.table}${namingCaveat(s)}`;
};

// Long detail text for the field panel.
export const optionsSourceText = (f) => {
    const s = f.optionsSource;
    if (!s) return f.lookupDecode || '';
    if (s.kind === 'glossary') {
        const list = s.glossaryCategoryName ? `“${s.glossaryCategoryName}”` : '(list undetermined)';
        return `Options list: Glossary → ${list} — edit in Lookup Table Options${namingCaveat(s)}`;
    }
    if (s.kind === 'reference') {
        return `Options list: ${s.referenceName} reference table — edit in Lookup Table Options${namingCaveat(s)}`;
    }
    return `Decoded by ${s.table}${namingCaveat(s)}`;
};

// Router state for the Lookup Table Options page, or null when the source isn't maintainable
// there. Reuses the {glossary,reference}TableDeepLink keys that tab already reads for global
// search (WI 305242), addressed by the id we hold rather than a second deep-link path.
export const optionsSourceNavState = (f) => {
    const s = f.optionsSource;
    if (!s) return null;
    if (s.kind === 'glossary') {
        if (s.glossaryCategory == null) return null;
        return { glossaryTableDeepLink: { glossaryCategory: s.glossaryCategory } };
    }
    if (s.kind === 'reference') {
        return { referenceTableDeepLink: { referenceName: s.referenceName, referenceTableName: s.table } };
    }
    return null;
};

// Same deep link as an href, for links opened in a new tab: router state doesn't survive
// one, so it rides on query params. The router's basename is '#', hence the '#/path' form.
export const optionsSourceHref = (f) => {
    const s = f.optionsSource;
    const navState = optionsSourceNavState(f);
    if (!navState) return null;
    const params = new URLSearchParams();
    params.set('tab', s.kind === 'reference' ? 'reference' : 'glossary');
    const deepLink = navState.glossaryTableDeepLink || navState.referenceTableDeepLink;
    Object.entries(deepLink).forEach(([key, value]) => {
        if (value !== null && value !== undefined) params.set(key, value);
    });
    return `#${TABLE_MAINTENANCE_ROUTE}?${params.toString()}`;
};
